<template>
  <div>
    <filter-bar ref="filter" mode="range" :scope="scope"
                export-code="EEForEduTeacherStats"
                @change="onFilter" @export="toExport" />
    <el-table v-loading="listLoading" :data="list" border
              size="small"
              @sort-change="sortChange">
      <el-table-column label="教育老师" prop="realName" align="center"
                       min-width="90"
                       fixed />
      <el-table-column label="手机号码" prop="mobile" align="center" width="110" />
      <el-table-column label="身份" prop="levelName" align="center" width="80" />
      <el-table-column label="所属督导" prop="supervisorRealName" align="center" width="90" />
      <el-table-column label="签到数据" align="center">
        <el-table-column label="服务大客户家数" prop="bigCustomerCount" align="center" width="110" />
        <el-table-column label="服务非大客户家数" prop="nonBigCustomerCount" align="center" width="120" />
        <el-table-column label="合计签到次数" prop="signCount" sortable="custom"
                         align="center"
                         width="120" />
      </el-table-column>
      <el-table-column label="大客户下单量（区间内签到过的大客户）" align="center">
        <el-table-column label="总订单量" prop="bigOrderCount" align="center" width="90" />
        <el-table-column label="余额/现金业绩" prop="bigBalanceMoney" align="center" width="110" />
        <el-table-column label="零售价业绩" prop="bigXiaoduMoney" align="center" width="100" />
        <el-table-column label="学费赠送业绩" prop="bigGiftMoney" align="center" width="110" />
        <el-table-column label="秒杀数量" prop="bigSeckillCount" align="center" width="80" />
        <el-table-column label="秒杀支付总金额" prop="bigSeckillMoney" align="center" width="120" />
      </el-table-column>
      <el-table-column label="非大客户下单量（区间内签到过的非大客户）" align="center">
        <el-table-column label="总订单量" prop="orderCount" align="center" width="90" />
        <el-table-column label="余额/现金业绩" prop="balanceMoney" align="center" width="110" />
        <el-table-column label="零售价业绩" prop="xiaoduMoney" align="center" width="100" />
        <el-table-column label="学费赠送业绩" prop="giftMoney" align="center" width="110" />
        <el-table-column label="秒杀数量" prop="seckillCount" align="center" width="80" />
        <el-table-column label="秒杀支付总金额" prop="seckillMoney" align="center" width="120" />
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page-no.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                @pagination="doQueryList" />
  </div>
</template>

<script>
import eduStatsApi from '@/api/count/eduStats'
import Pagination from '@/components/Pagination'
import filterBar from './filterBar.vue'

/**
 * 技术老师签到与出货（周/月模板）
 * 签到与出货同一区间；出货只算区间内被该老师签到过的客户，大/非大客户分开
 */
export default {
  components: { Pagination, filterBar },
  props: { scope: { type: Object, default: () => ({}) } },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      filter: {},
      query: { pageNo: 1, pageSize: 20, signCountSortSign: -1 }
    }
  },
  mounted() {
    this.filter = this.$refs.filter.buildQuery()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    onFilter(q) {
      this.filter = q
      this.doQueryList({ pageNo: 1 })
    },
    sortChange({ prop, order }) {
      if (prop === 'signCount') {
        this.query.signCountSortSign = order === 'ascending' ? 1 : -1
        this.doQueryList({})
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      eduStatsApi.teacherList({ ...this.filter, ...this.query }).then(({ data }) => {
        this.list = (data && data.list) || []
        this.total = (data && data.total) || 0
      }).catch(() => {
        this.list = []
        this.total = 0
      }).finally(() => { this.listLoading = false })
    },
    toExport() {
      this.$router.push('/export/list?code=EEForEduTeacherStats')
    }
  }
}
</script>
